
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("LXDBu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $46ecaaf927e3351d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $46ecaaf927e3351d$export$2e2bcd8739ae039 = {
    'fabric.editor.headingLink.ascSortingLabel': 'aufsteigend',
    'fabric.editor.headingLink.copied': 'Kopiert!',
    'fabric.editor.headingLink.copyAnchorLink': "Link in \xdcberschrift kopieren",
    'fabric.editor.headingLink.copyAriaLabel': 'Kopieren',
    'fabric.editor.headingLink.descSortingLabel': 'absteigend',
    'fabric.editor.headingLink.failedToCopy': 'Kopieren ist fehlgeschlagen',
    'fabric.editor.headingLink.noneSortingLabel': 'Keine',
    'fabric.editor.inlineComment.marker.end': 'Ende des Inline-Kommentars',
    'fabric.editor.inlineComment.marker.start': 'Beginn des Inline-Kommentars'
};

});


//# sourceMappingURL=de.6d81a973.js.map
